import { Star } from "@phosphor-icons/react";

export const StarRating = ({ rating = 0, size = 14, showValue = true }) => (
  <span className="inline-flex items-center gap-1">
    <Star size={size} weight="fill" className="text-amber-500" aria-hidden />
    {showValue && <span className="text-sm font-medium text-stone-800">{Number(rating).toFixed(1)}</span>}
  </span>
);
